export const BASE_PATH = '/flights'
export const DETAILS_PATH = (flightId: string | number) => `${BASE_PATH}/details/${flightId}`

export const DETAILS_BASE_PATH = `${BASE_PATH}/details`
export const RESULTS_BASE_PATH = `${BASE_PATH}/results`
export const SEO_BASE_PATH = `${BASE_PATH}/[seoUrl]`
export const MERCH_RESULTS_BASE_PATH = `${BASE_PATH}/merchresults`
export const SIGN_OUT_ROUTE = '/signout'
export const ACCOUNTS_WALLET = '/accounts/wallet'
